import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import SamuraiJSApp from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
    
    root.render(
        <SamuraiJSApp />
    );
    reportWebVitals();

